/**
 * Odometer Animation Recruit page
 */


declare var Odometer: any;

const odoMeter = () => {
  function startCount(element: HTMLElement) {
    const counter = element.querySelector('[data-odometer]') as HTMLElement;
    let targetValue = parseInt(counter?.getAttribute('data-odometer') || '0', 10);

    if (counter && targetValue >= 0) {
      const od = new Odometer({
        el: counter,
        value: 0,
        format: '(d)',
        duration: 2000 // You can adjust this for smoother speed
      });

      // Directly update to the final value
      od.update(targetValue);
    }
  }

  const odoElements = document.querySelectorAll('.js-odo');

  const options = {
    root: null,
    rootMargin: '0px',
    threshold: 0.1
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        startCount(entry.target as HTMLElement);
        observer.unobserve(entry.target); // Stop observing after it animates once
      }
    });
  }, options);

  if (odoElements) {
    odoElements.forEach((element) => {
      observer.observe(element);
    });
  }
};

export default odoMeter;